var _use, _symbol;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFastly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 61 65",
    fill: "#fff",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#A",
    x: 0.5,
    y: 0.5
  })), _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    id: "A",
    overflow: "visible"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.346 29.754l-1.034-1.034-5.285 4.606a2.51 2.51 0 0 0-.857-.145c-1.422 0-2.586 1.196-2.586 2.65 0 1.47 1.164 2.65 2.586 2.65s2.586-1.196 2.586-2.65c0-.275-.048-.55-.113-.792zm20.96 20.573L56.29 7.725h-13.7v3.992c-2.812-1.697-5.964-2.893-9.3-3.523h.08v-4.72h1.665V0H21.253v3.475h1.665v4.72h.097C9.923 10.602 0 22.06 0 35.863 0 51.4 12.59 64 28.138 64c5.3 0 10.263-1.47 14.497-4.024L45.106 64h14.465V50.3h-3.265zm-27.32-.027v-1.616h-1.63v1.6c-7.354-.42-13.22-6.335-13.608-13.7h1.632v-1.632h-1.616c.436-7.305 6.287-13.156 13.592-13.576v1.616h1.632v-1.616c7.208.388 13 6.044 13.64 13.172v.47H40.98v1.632h1.648v.453c-.614 7.143-6.432 12.8-13.64 13.188z",
    stroke: "none",
    fill: "#e82c2a",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastly);
export default __webpack_public_path__ + "97131/static/media/fastly.b233e649d48a4a2a28ec3ec6889abef6.svg";
export { ForwardRef as ReactComponent };